import type { Motor_Lead_Extensions } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export const mleTableColumns: EquipmentTableColumn<Motor_Lead_Extensions>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "Include KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_koc_timestamp",
    header: "KOC Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Include Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_ecopetrol_timestamp",
    header: "Ecopetrol Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "part_number",
    header: "Part Number",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "family",
    header: "Family",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "series",
    header: "Series",
    isNumber: true,
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "max_pothead_temperature_fahrenheit",
    header: "Max Pothead Temperature (F)",
    sortable: true,
    adminOnly: false
  },
  {
    editable: true,
    field: "length_feet",
    header: "Length (ft)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "gauge",
    header: "Gauge",
    isNumber: true,
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "kv",
    header: "kV",
    isNumber: true,
    sortable: true
  },
  {
    editable: true,
    field: "max_temperature_fahrenheit",
    header: "Max Temperature (F)",
    isNumber: true,
    sortable: true
  },
  {
    editable: true,
    field: "width_inches",
    header: "Width (in)",
    isNumber: true,
    sortable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "depth_inches",
    header: "Depth (in)",
    isNumber: true,
    sortable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "amp_factor",
    header: "Amp Factor",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "resistance_per_1000_ft",
    header: "R",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "impedance_60_hz_per_1000_ft",
    header: "X",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "pound_per_foot",
    header: "Pounds per Foot",
    isNumber: true,
    sortable: true,
    adminOnly: true,
    decimalPlaces: 6
  }
];
